import { Breakpoints, Container, ContainerPadding, DecorativeImage, DesignTokenSizeEnum, Layout, styled, Text, TextAlignment, TextTag, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import React, { useRef } from "react";

const HeroContainer = styled.div`
	background: var(--c-red);
	background: linear-gradient(180deg, var(--c-red) 0%, var(--c-red) 50%, rgba(214, 0, 16, 1) 100%);
	padding-top: var(--s2-one-hub-navigation-top-bar-height);
	& * {
		color: var(--c-black) !important;
		line-height: 1.05 !important;
		text-wrap: pretty !important;
		text-wrap: balance !important;
	}
`;
const ColumnsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: var(--size-${DesignTokenSizeEnum.dynamic0100});
	padding: var(--size-${DesignTokenSizeEnum.dynamic0200}) 0;
	@media (min-width: ${Breakpoints.b1280}px) {
		flex-direction: row;
		flex-wrap: nowrap;
        gap: var(--size-${DesignTokenSizeEnum.grid001});
    }
`;
const TextColumn = styled.div`
	flex: 1 1 100%;
	@media (min-width: ${Breakpoints.b1280}px) {
		flex: 0 0 calc(7 / 22 * 100%);
	}
`;
export const ArrowContainer = styled.div`
	margin-top: -20px;
	margin-bottom: var(--size-${DesignTokenSizeEnum.dynamic0300});
	text-align: center;
	width: 100%;
	position: relative;
	z-index: 1;
	svg {
		cursor: pointer;
		transition: 200ms;
		transform: scale(1);
		&:hover {
			transform: scale(.9);
		}
	}

	svg circle {
		fill: var(--c-white);
	}
	svg path {
		fill: var(--c-red);
	}
`;


export function HeroSection() {
	const heroRef = useRef<HTMLDivElement>(null);

	const handleAnchor = (id: string) => {
		const target = document.getElementById(id);
		if (!target) return;

		target.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};


	return (
		<React.Fragment>
			<HeroContainer ref={heroRef}>
				<Layout appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 1 },
						{ name: 'hero', columns: 22 },
						{ name: '.', columns: 1 }
					],
				}}>
					<ColumnsContainer>
						<TextColumn>
							<Text
								tag={TextTag.h1} appearance={ TokenTextAppearance.headline600 } bold
								textAlign={{
									[Breakpoints.default]: TextAlignment.center,
									[Breakpoints.b1280]: TextAlignment.left,
								}}
							>
								Por suerte, siempre hay alguien que te desea carbón
							</Text>
							<Container wrap={'always'} padding={{ top: {
								[Breakpoints.default]: ContainerPadding.dynamic0100,
								[Breakpoints.b1280]: ContainerPadding.dynamic0150,
							} }}>
								<Text
									tag={TextTag.p} appearance={ TokenTextAppearance.headline400 } bold
									textAlign={{
										[Breakpoints.default]: TextAlignment.center,
										[Breakpoints.b1280]: TextAlignment.left,
									}}
								>
									Golf GTI
								</Text>
								<Text
									tag={TextTag.p} appearance={ TokenTextAppearance.headline300 }
									textAlign={{
										[Breakpoints.default]: TextAlignment.center,
										[Breakpoints.b1280]: TextAlignment.left,
									}}
								>
									en Negro Carbón
								</Text>
							</Container>
						</TextColumn>
						<div>
							<DecorativeImage src='https://assets.volkswagen.com/is/image/volkswagenag/gti_carfront?Zml0PWNyb3AlMkMxJndpZD0xOTUxJmhlaT0xMDk4JmZtdD1wbmctYWxwaGEmYmZjPW9mZiY4ZDky' />
						</div>
					</ColumnsContainer>
				</Layout>
			</HeroContainer>
			<div id='anchorEndPosition'></div>
			<ArrowContainer>
				<svg onClick={() => handleAnchor("anchorEndPosition")} width="40" height="40" viewBox="0 0 58 59" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="29" cy="29.6064" r="28.9399" />
					<path
					d="M30.5571 14.4691C30.5571 13.6087 29.8596 12.9112 28.9993 12.9112C28.1389 12.9112 27.4414 13.6087 27.4414 14.4691L30.5571 14.4691ZM27.8977 45.844C28.5061 46.4524 29.4925 46.4524 30.1008 45.844L40.0149 35.93C40.6232 35.3216 40.6232 34.3352 40.0149 33.7269C39.4065 33.1185 38.4201 33.1185 37.8117 33.7269L28.9993 42.5393L20.1868 33.7269C19.5784 33.1185 18.5921 33.1185 17.9837 33.7269C17.3753 34.3352 17.3753 35.3216 17.9837 35.93L27.8977 45.844ZM27.4414 14.4691L27.4414 44.7425L30.5571 44.7425L30.5571 14.4691L27.4414 14.4691Z"
					/>
				</svg>
			</ArrowContainer>
		</React.Fragment>
	);
}